import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

import Report from 'src/constants/report';

export default autoGeneratedReducer<Report>(Report.LaborMarket);
